import React, { Component } from 'react';
import Button from "@material-ui/core/Button";
import {withStyles} from "@material-ui/styles";
import {
    organisationDetails,
    saveOrUpdateOrganisationDetails, trackExport,
} from "../../util/ApiUtils";
import * as htmlDocx from "html-docx-js/dist/html-docx";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import {SystemUpdateAltTwoTone} from "@material-ui/icons";
import {GreenButton} from "../common/ButtonsConstants";
import * as CommonUtils from "../../util/CommonUtils";
import {Editor} from "@tinymce/tinymce-react";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import { t } from '../../i18n';

const top = 50;
const left = 50;
const classes = (theme => ({

    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    },
}));

class Scope extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            orgId: "",
            orgScope: "",
            content: "",
            organisation: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.editContent = this.editContent.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    orgId: response.id,
                    orgScope: response.scope,
                    content: response.scope,
                    organisation: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    editContent = () => {
        this.setState({
            isEdit: !this.state.isEdit
        });
    };

    handleEditorChange = (content, editor) => {
        this.setState({ content: content });
    };

    handleSubmit(event) {
        event.preventDefault();
        const organisationDetailsRequest = Object.assign(this.state.organisation,
            {id: this.state.orgId, scope: this.state.content}
        );
        console.log(organisationDetailsRequest);
        saveOrUpdateOrganisationDetails(organisationDetailsRequest)
            .then(() => {
                this.setState({
                    isEdit: false,
                })
                NotificationManager.success(t('app.notifications.success'), t('context.scope.updatedSuccess'), 5000);
            }).catch(error => {
            NotificationManager.error(t('app.notifications.error'), t('app.notifications.genericError'), 5000);
        });
    }

    render() {
        const { state } = this;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                {t('context.scope.title')}
            </Typography>
                {
                    !state.isEdit ?
                        (
                            <React.Fragment>
                                {!isDemo && !isViewer && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => { const title = t('context.scope.title'); saveAs(htmlDocx.asBlob(this.toRevisionTable(this.props.revision) + title + state.content), this.props.exportFileName); trackExport(title); }} style={{ float: 'right' }}>{t('context.scope.export')}</GreenButton>}
                                <div style={{ clear: 'both' }}/>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: state.content
                                    }}>
                                </div>
                                <Button
                                    onClick={this.editContent}
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    disabled={isAuditor || isViewer}
                                >
                                    {t('context.scope.edit')}
                                </Button>
                            </React.Fragment>
                        )
                        :
                        <React.Fragment>
                            <GreenButton
                                onClick={this.handleSubmit}
                                type="submit"
                                style={{ float: 'right' }}
                                variant="contained"
                                color="primary"
                            >
                                {t('context.scope.save')}
                            </GreenButton>
                            <div style={{ clear: 'both' }}/>
                            <Editor
                                apiKey="y9iyidzzc5orr4c7nqrr9edoyr9on123bjjw4dfjvfoj54hu"
                                value={ state.content }
                                init={{
                                    height: 900,
                                    branding: false,
                                    menubar: false,
                                    plugins: [
                                        'advlist autolink lists link image charmap print preview anchor',
                                        'searchreplace visualblocks code fullscreen',
                                        'insertdatetime media table paste code help wordcount'
                                    ],
                                    toolbar:
                                        'undo redo | formatselect | bold italic backcolor | \
                                        alignleft aligncenter alignright alignjustify | \
                                        bullist numlist outdent indent | removeformat | help'
                                }}
                                onEditorChange={this.handleEditorChange}
                            />
                        </React.Fragment>
                }
                <NotificationContainer/>
        </div>;
    }
    toRevisionTable(revision) {
        return '<table style="width:100%">' +
            '<tr>' +
            '<b>' + t('context.common.revision') + ' ' + revision.number + '  ' + t('context.common.author') + ': ' + revision.author + '</p>' +
            '</tr>' +
            '<tr>' +
            '<td>' + t('context.common.approvedFor') + ': ' + revision.approvedBy + ' ' + t('context.common.on') + ' ' + moment(revision.date).format('DD/MM/YYYY') + '</td>' +
            '</tr>' +
            '</table>';
     }
 }

 export default withStyles(classes)(Scope);
